/**
 * OSS-Report Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/oss
 * § 18 UStG-OSS (One-Stop-Shop) für intra-EU-B2C-Umsatz.
 */

const COUNTRIES = [
  { code: 'DE', name: 'Deutschland', vatRate: 19 },
  { code: 'AT', name: 'Österreich', vatRate: 20 },
  { code: 'NL', name: 'Niederlande', vatRate: 21 },
  { code: 'FR', name: 'Frankreich', vatRate: 20 },
  { code: 'IT', name: 'Italien', vatRate: 22 },
  { code: 'ES', name: 'Spanien', vatRate: 21 },
  { code: 'BE', name: 'Belgien', vatRate: 21 },
  { code: 'PL', name: 'Polen', vatRate: 23 },
];

function quarterOf(d) {
  const m = d.getMonth();
  return `${d.getFullYear()}-Q${Math.floor(m / 3) + 1}`;
}

export function ossReportFixture() {
  const now = new Date();
  const ytdGross = 8_650_00; // Cent → 8.650 EUR
  const threshold = 10_000_00;

  // Quarter-Aggregation: aktuelles + 3 vergangene Quartale
  const quarters = [];
  for (let q = 3; q >= 0; q -= 1) {
    const quarterDate = new Date(now.getFullYear(), now.getMonth() - q * 3, 1);
    const quarter = quarterOf(quarterDate);
    const byCountry = COUNTRIES.map((c, i) => {
      const gross = Math.round((250 + i * 30 + q * 50) * 100); // Cent
      const vatAmount = Math.round((gross * c.vatRate) / (100 + c.vatRate));
      const net = gross - vatAmount;
      return {
        countryCode: c.code,
        countryName: c.name,
        vatRate: c.vatRate,
        gross,
        net,
        vatAmount,
      };
    });
    quarters.push({
      quarter,
      total: byCountry.reduce((s, r) => s + r.gross, 0),
      totalVat: byCountry.reduce((s, r) => s + r.vatAmount, 0),
      byCountry,
    });
  }

  return {
    currency: 'EUR',
    threshold: {
      ytdGross,
      limit: threshold,
      year: now.getFullYear(),
      remaining: Math.max(0, threshold - ytdGross),
      reached: ytdGross >= threshold,
    },
    quarters: quarters.reverse(), // älteste zuerst
    generatedAt: new Date().toISOString(),
  };
}
